<template>
    <section class="header-animation-container">
        <div class="header-animation">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header-animation__title"
                v-html="pageHeader.title"
            ></div>

            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="pageHeader.subtitle"
                class="header-animation__subtitle"
                v-html="pageHeader.subtitle"
            ></div>

            <ProductGuide
                v-if="pageHeader.product_guide"
                :product-guide="pageHeader.product_guide"
            />

            <InteractiveAnimation
                :title="pageHeader.animation.title"
                :animation="pageHeader.animation.data"
                :tooltip-set="pageHeader.animation.tooltip_set"
                :tooltip-content-position="pageHeader.animation.tooltip_content_position"
            />

            <div class="header-animation__divider-text">
                {{ $page.props.settings.translations.whyUse.title }}
            </div>

            <SellingPoints
                v-if="pageHeader.selling_points"
                :selling-points="pageHeader.selling_points"
            />

            <VideoModal
                v-if="pageHeader.video"
                :page-header="pageHeader"
            />

            <Media
                v-else
                :type="pageHeader.media_type"
            />
        </div>
    </section>
</template>

<script setup>
import Media from '../../header-components/media/watson-theme-header-media.vue';
import SellingPoints from '../../header-components/selling-points/watson-theme-selling-points.vue';
import VideoModal from '../../header-components/video-modal/watson-theme-video-modal.vue';
import ProductGuide from '../../header-components/product-guide/watson-theme-product-guide.vue';
import InteractiveAnimation from '../../../../../components/interactive-animation/watson-theme-interactive-animation.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-animation";
</style>
